import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 
import { Box, Grid, Typography } from '@mui/material';
import DataBox from '../../../general/data/DataBox';
import InfoRow from '../../../general/inputs/InfoRow';
import Button from '../../../general/inputs/Button';
import { setDashboardSection } from '../../../../redux/features/general/navigation';
import moment from 'moment';

interface Props { 

}; 

const FreeTrial: React.FC<Props> = ({ }) => {
    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const group = useAppSelector(state => state.billing.group); 

    const [endOfFreeTrial, setEndOfFreeTrial] = useState(''); 
    const [startOfFreeTrial, setStartOfFreeTrial] = useState(''); 

    const handlePaywallNavigation = async () => { 
        dispatch(setDashboardSection('plans')); 
    }; 

    useEffect(() => { 
        if (group) { 
            setStartOfFreeTrial(moment(group.createdAt).utc(true).format('LL')); 

            // --- START OF FIX ---
            // If a custom trialEndDate exists in the database, use it.
            // Otherwise, fall back to the default 14-day calculation.
            if (group.trialEndDate) {
                setEndOfFreeTrial(moment(group.trialEndDate).utc(true).format('LL'));
            } else {
                setEndOfFreeTrial(moment(group.createdAt).utc(true).add(14, "days").format('LL')); 
            }
            // --- END OF FIX ---
        }; 
    },[group]); 

    return (
        <DataBox>
            <InfoRow 
                title={String(t('planDetails'))}
                extraStyle={{ '&:hover': { backgroundColor: 'transparent', cursor: 'default' }}}
                isDisabled
            />

            <InfoRow 
                title={String(t('medcaProMonthly'))}
                titleStyle={{ fontWeight: 'bold', fontSize: 18 }}
                extraStyle={{ '&:hover': { backgroundColor: 'transparent', cursor: 'default' }, mb: 2 }}
                isDisabled
            />

            <Grid container spacing={2} sx={{ width: '100%', textAlign: 'center', mb: 3 }}>
                <Grid item xs={12} sm={4}>
                    <Typography variant="caption" sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>{String(t('startDate'))}</Typography>
                    <Typography variant="body1" fontWeight="bold">{startOfFreeTrial}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="caption" sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>{String(t('endsOn'))}</Typography>
                    <Typography variant="body1" fontWeight="bold">{endOfFreeTrial}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography variant="caption" sx={{ color: 'rgba(0, 0, 0, 0.6)' }}>{String(t('currentPlan'))}</Typography>
                    <Typography variant="body1" fontWeight="bold" sx={{ color: 'darkblue' }}>{String(t('freeTrial'))}</Typography>
                </Grid>
            </Grid>

            {/* Hide the subscribe button for special clients during their trial */}
            {!(group?.trialEndDate || group?.customPriceId) && (
                <Button 
                    title={String(t('addPaymentMethod'))}
                    triggerFunction={handlePaywallNavigation}
                    extraStyle={{ 
                        height: 'auto',
                        minHeight: '40px',
                        whiteSpace: 'normal',
                        lineHeight: '1.4',
                        padding: '6px 12px',
                        textAlign: 'center',
                        width: '80%',
                        maxWidth: '250px'
                    }}
                />
            )}
        </DataBox>
    );
};

export default FreeTrial;